export enum HqRole {
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN',
  DEVELOPER = 'DEVELOPER',
}
